export type LabelTemplateType =
  | "packaging_carton"
  | "packaging_pallet"
  | "shipping_label";

export function isLabelTemplateActive(
  payload: unknown,
  type: LabelTemplateType,
): boolean {
  if (!payload || typeof payload !== "object") return false;

  const capabilities = (payload as { capabilities?: unknown }).capabilities;
  if (!capabilities || typeof capabilities !== "object") return false;

  return (capabilities as Record<string, unknown>)[type] === true;
}
